import React, { useState, useEffect, useRef } from 'react';

import { message, Drawer, Form, Card, Row, Col, Space, Input, InputNumber, Select, Button, Dropdown,Radio } from 'antd';


// import request from '../../../service/flights/request'
// import { API_BIDDING_GET, API_BIDDING_EDIT, API_BIDDING_ADD } from '../../../service/flights/Flights'

// import SPSupplierProductTypes from '../SPSupplierProductTypes'
// import SPIsShowquchechengshi from '../SPIsShowquchechengshi'

import { diffCityPRCarLineAdd, diffCityPRCarLineUpdate, getDiffCityList } from 'hooks/carRental/store';

import emiter, {
  EVENT_CARRENTAL_ADD_REMOTERETURN,
  EVENT_CARRENTAL_EDIT_REMOTERETURN,
  EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH, EVENT_CARRENTAL_BRANCH_MODAL_OPEN, EVENT_CARRENTAL_UPDATE_WEBSITE_LIST,
} from '../../../../events'

const { TextArea } = Input;

interface PropsType {
  enums?: any;
}

const SPDifCityRemoteReturnDrawer: React.FC<PropsType> = (props) => {
  const { enums } = props

  const [mainForm] = Form.useForm();
  const [open, setOpen] = useState(false);
  const dataRef = useRef({});
  const [disabled, setDisabled] = useState(false);
  const [actionBar, setActionBar] = useState(<></>);

  const [cityList, setCityList] = useState([]);

  const [detailDrawerTitle, setDetailDrawerTitle] = useState('编辑跨城取还车路线');
  const lineCode = useRef(0);


  const drawerWidth = '70%';

  const mainFormFields = {
    quchechengshi: { name: 'pickup_city_id', label: '取车城市', required: true, message: '取车城市错误!', placeholder: '取车城市', },
    huanchechengshi: { name: 'return_city_id', label: '还车城市', required: true, message: '还车城市错误!', placeholder: '还车城市', },
    kuachenghuanchefeiyong: { name: 'service_fee', label: '跨城还车费用', required: true, message: '跨城还车费用错误!', placeholder: '跨城还车费用', },
    kucunzhanyongxiaoshi: { name: 'stock_occupy_time', label: '库存占用小时', required: true, message: '库存占用小时错误!', placeholder: '库存占用小时', },
  };

  // const loadForView = (data: any) => {
  //     return request({
  //         url: API_BIDDING_GET,
  //         method: 'POST',
  //         data:{id:+data},
  //     })
  // }

  const loadForEdit = (data: any) => {
      // return request({
      //     url: API_BIDDING_GET,
      //     method: 'POST',
      //     data:{boothId:+data},
      // })
  }

  const onOpen = () => {
    setOpen(true);
    mainForm.resetFields();
  };

  const onClose = () => {
    dataRef.current = {};
    setActionBar(<></>);
    setDisabled(false);
    setOpen(false);
    lineCode.current = 0;
    mainForm.resetFields();
  };


  // const onView = (record: any) => {
  //   loadForView(record.orderNo, (data:any) => {
  //       dataRef.current = data;
  //       setActionBar(<ViewActionBar />);
  //       onOpen();
  //       mainForm.setFieldsValue(data);
  //       setDisabled(true);
  //    })
  // };

  const onEdit = (record: any) => {
    setActionBar(<EditActionBar />);
    setOpen(true);
    lineCode.current = record?.diff_city_pr_car_line_code;
    mainForm.setFieldsValue(record);
    // loadForEdit(record.id).then((res: any) => {
    //   dataRef.current = res;
    //   setActionBar(<EditActionBar />);
    //   setDetailDrawerTitle('编辑报价位');
    //   onOpen();
    //   mainForm.setFieldsValue(res);
    //   setDisabled(false);
    // }
    // ).catch((error: any) => {
    //   message.error(error?.msg);
    // })
  }

  const edit = () => {
    // request({
    //   url: API_BIDDING_EDIT,
    //   method: 'POST',
    //   data: {...mainForm.getFieldsValue(),id:(dataRef.current as any).id},
    // }).then((res: any) => {
    //   onClose();
    //   emiter.emit(EVENT_FLIGHTS_SEARCH_BIDDING, {});
    // }).catch((error: any) => {
    //   message.error(error?.msg);
    // })
  };

  const onEditFinish = () => {
    edit();
  };

  const onDrawerClose = () => {
    onClose();
  };

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_ADD_REMOTERETURN, onAdd);
    emiter.on(EVENT_CARRENTAL_EDIT_REMOTERETURN, onEdit);
    loadCityList();
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_ADD_REMOTERETURN)
      emiter.removeAllListeners(EVENT_CARRENTAL_EDIT_REMOTERETURN)
    }
  }, []);

  const EditActionBar = () => {
    return (
      <Space>
        <Button onClick={onDrawerClose}>关闭</Button>
        <Button type="primary" onClick={onAddFinish}>保存</Button>
      </Space>
    );
  };

  const AddActionBar = () => {
    return (
      <Space>
        <Button onClick={onDrawerClose}>关闭</Button>
        <Button type="primary" onClick={onAddFinish}>保存</Button>
      </Space>
    );
  };

  const add = () => {
    // request({
    //   url: API_BIDDING_ADD,
    //   method: 'POST',
    //   data: mainForm.getFieldsValue(),
    // }).then((res: any) => {
    //   onClose();
    //   emiter.emit(EVENT_FLIGHTS_SEARCH_BIDDING, {});
    // }).catch((error: any) => {
    //   message.error(error?.msg);
    // })
  }

  const onAdd = () => {
    setActionBar(<AddActionBar />);
    setDetailDrawerTitle('新增跨城取还车路线');
    onOpen();
  }

  const onAddFinish = () => {
    mainForm.validateFields().then((values: any) => {
      const { pickup_city_id, return_city_id, service_fee, stock_occupy_time } = values || {};
      let requestMethod = diffCityPRCarLineAdd;
      const params: any = {
        pickup_city_id,
        return_city_id,
        service_fee: +service_fee * 100,
        stock_occupy_time: +stock_occupy_time,
      }
      if (lineCode.current) {
        params.diff_city_pr_car_line_code = lineCode.current;
        requestMethod = diffCityPRCarLineUpdate;
      }
      requestMethod(params).then((res: any) => {
        const { errno } = res || {};
        if (errno === 0) {
          onClose();
          message.success('操作成功');
          emiter.emit(EVENT_CARRENTAL_DIFF_PR_CAR_SEARCH);
        }
      });
    });
    add();
  };

  const loadCityList = () => {
    getDiffCityList({}).then((res: any) => {
      const cityList = res?.data?.city_list || [];
      setCityList(cityList);
    });
  }

  return (
    <>
      <Drawer
        title={detailDrawerTitle}
        width={drawerWidth}
        onClose={onClose}
        open={open}
        destroyOnClose
        extra={ actionBar }
      >
        <Form form={mainForm} labelCol={{ span: 3 }} disabled={disabled}>
          <Form.Item
            name={ mainFormFields.quchechengshi.name }
            label={ mainFormFields.quchechengshi.label }
            rules={[
              {
                required: mainFormFields.quchechengshi.required,
                message: mainFormFields.quchechengshi.message
              }
            ]}
          >
            <Select disabled={!!lineCode.current}>
              {cityList.map((item: any) => (
                <Select.Option
                  allowClear
                  value={item.city_id}
                  placeholder={mainFormFields?.quchechengshi.placeholder}
                >{item.city_name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={ mainFormFields.huanchechengshi.name }
            label={ mainFormFields.huanchechengshi.label }
            rules={[
              {
                required: mainFormFields.huanchechengshi.required,
                message: mainFormFields.huanchechengshi.message
              }
            ]}
          >
            <Select disabled={!!lineCode.current}>
              {cityList.map((item: any) => (
                <Select.Option
                  allowClear
                  value={item.city_id}
                  placeholder={mainFormFields?.huanchechengshi.placeholder}
                >{item.city_name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={ mainFormFields.kuachenghuanchefeiyong.name }
            label={ mainFormFields.kuachenghuanchefeiyong.label }
            rules={[
              {
                required: mainFormFields.kuachenghuanchefeiyong.required,
                message: mainFormFields.kuachenghuanchefeiyong.message
              }
            ]}
          >
            <InputNumber style={{ width: '100%' }} addonAfter="元" min={1} max={5000} />
          </Form.Item>
          <Form.Item
            name={ mainFormFields.kucunzhanyongxiaoshi.name }
            label={ mainFormFields.kucunzhanyongxiaoshi.label }
            rules={[
              {
                required: mainFormFields.kucunzhanyongxiaoshi.required,
                message: mainFormFields.kucunzhanyongxiaoshi.message
              }
            ]}
          >
            <InputNumber style={{ width: '100%' }} addonAfter="小时" min={1} max={5000} />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}

export default SPDifCityRemoteReturnDrawer;
